import { attr } from '@ember-data/model';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
export default CatalogFragment.extend({
  itemOptionId: attr('string'),
  name: attr('string'),
  description: attr('string'),
  color: attr('string'),
  ordinal: attr('number'),
  itemVariationCount: attr('number', {
    defaultValue: 0
  })
}).reopenClass({
  _modelNameForMigration: 'connect/item-option-value/data'
});